export default {
    app: {
        name: 'BZUCO Inspector',
        reseted: 'Bilety zresetowane...',
        networkError: 'Błąd serwera, sprawdź połączenie z internetem...',
        networkNotAvailable: 'Brak połączenia'
    },
    menu: {
        test: 'Test czytnika kodów',
        settings: 'Ustawienia',
        admin: 'Administracja',
        resetTickets: 'Reset biletów',
        resetState: 'Reset stanu aplikacji',
        logout: 'Wyloguj'
    },
    home: {
        login: 'Zaloguj się',
        lastEvent: 'Sprawdź ostatnie wydarzenie / strefę',
        lastEvents: 'Sprawdź ostatnio<br />wczytane wydarzenia',
        lastZones: 'Sprawdź ostatnio<br />wczytane strefy',
        chooseEvent: 'Wybierz wydarzenie',
        checkEvents: 'Sprawdź<br />wydarzenia',
        checkZones: 'Sprawdź<br />strefy',
        scanConfig: 'Scan QR code'
    },
    configScanner: {
        title: 'Configuration QR',
        notConfig: 'Unrecognized configuration code',
        loggedIn: 'Logged in:',
        setsSelected: 'Selected ticketsets:',
        zonesSelected: 'Selected zone:',
        loginRequiredTitle: 'Login required',
        loginRequiredMessage: 'You need to log in before loading ticketsets or zones.',
        ok: 'OK'
    },
    event: {
        chooseEvent: 'Wybierz wydarzenie',
        chooseEventPast: 'Minione wydarzenia',
        confirm: 'Potwierdź wybór wydarzeń',
        showPast: 'pokaż minione'
    },
    zone: {
        chooseZone: 'Wybierz strefę / strefy',
        confirm: 'Potwierdź wybór stref'
    },
    ticketsets: {
        chooseTicketsets: 'Wybierz zestawy biletów',
        selectAll: 'Wybierz wszystkie',
        ticketCount: 'Liczba biletów:'
    },
    scanner: {
        tickets: 'Bilety:',
        startReader: 'Uruchom czytnik',
        startReaderDescription:
            'Przeglądarka wymaga interakcji użytkownika do odtwarzania dźwięków systemowych. Potwierdź przyciskiem "OK".',
        specialWarning: 'Ostrzeżenie',
        specialType: 'Bilet specjalnego typu:',
        refuse: 'Odrzuć',
        confirm: 'Potwierdź',
        messageSuccess: 'Kod {code} zaakceptowany',
        messageSuccessPrice: 'Kod {code} zaakceptowany<br /><big>Cena: <b>{price}</b></big>',
        messageSuccessTicketsetPrice: 'Kod {code} zaakceptowany<br /><big>Zestaw: <b>{ticketset} / {price}</b></big>',
        messageSuccessTicketset: 'Kod {code} zaakceptowany<br /><big>Zestaw: <b>{ticketset}</b></big>',
        messageSuccessEvent: 'Kod {code} zaakceptowany<br /><big>Wydarzenie: <b>{event}</b>, zestaw: {ticketset}</big>',
        messageSuccessNosend: 'Kod {code} zaakceptowany (nie wysłano)',
        messageRead: 'Odczytano kod {code}',
        messageUsed: 'Kod {code} już użyty',
        messageNotUsable: 'Kod {code} nie do użycia',
        messageUnsend: 'Kod {code} już użyty (przeze mnie, nie wysłano)',
        messageNotFound: 'Kod <b>{code}</b> nie znaleziony',
        messageBadSlot: 'Kod {code} nieprawidłowy dla tej strefy/slotu',
        messageExtra1: 'użyty na urządzeniu: <b>{device}</b>, data: <b>{date}</b>',
        manualTitle: 'Ręczne wprowadzenie kodu',
        loading: 'wczytywanie biletów...',
        nfcNotFound: 'Żaden bilet na karcie nie jest ważny'
    },
    login: {
        title: 'Logowanie do aplikacji',
        username: 'Nazwa użytkownika',
        password: 'Hasło',
        login: 'Zaloguj'
    },
    settings: {
        title: 'Ustawienia',
        sound: 'Dźwięk',
        soundSub: 'Włącz powiadomienia dźwiękowe',
        camera: 'Kamera',
        nfc_heading: 'NFC',
        nfc: 'Czytaj tagi NFC',
        language: 'Język',
        langCs: 'Czeski',
        langEn: 'Angielski',
        langDe: 'Niemiecki',
        langHr: 'Chorwacki',
        langHu: 'Węgierski',
        langPl: 'Polski',
        langSk: 'Słowacki',
        qTitle: 'Zaawansowane ustawienia kamery',
        qPatchSize: 'Rozmiar okna dekodowania',
        qFrequency: 'Częstotliwość dekodowania',
        groupDisplay: 'Pokaż nazwę grupy / kategorii podczas kontroli',
        groupDisplayNone: 'Nic nie pokazuj',
        groupDisplayTicketset: 'Pokaż nazwę zestawu',
        groupDisplayTicketsetPrice: 'Pokaż zestaw i cenę',
        groupDisplayPrice: 'Pokaż cenę',
        groupDisplayEvent: 'Pokaż wydarzenie i zestaw',
        olderEvents: 'Jak długo pokazywać starsze wydarzenia po wygaśnięciu',
        olderEventsWeek: 'Tydzień',
        olderEventsMonth: 'Miesiąc',
        olderEvents3Month: '3 miesiące',
        olderEvents6Month: '6 miesięcy',
        olderEventsYear: '1 rok',
        olderEventsAll: 'Pokaż wszystkie',
        olderEventsAllList: 'wszystkie',
        showTicketCount: 'Pokaż liczbę biletów',
        showStatistics: 'Pokaż statystyki',
        queueTitle: 'Kody w kolejce do wysłania',
        queueSending: 'wysyłanie w toku',
        queueYes: 'TAK',
        queueNo: 'NIE',
        queueEmpty: 'Kolejka jest pusta'
    },
    statistics: {
        title: 'Statystyki użycia biletów',
        zone: 'Strefa',
        today: 'Dziś',
        total: 'Razem',
        refresh: 'Odśwież dane'
    },
    verify: {
        title: 'Weryfikacja biletu',
        enterCode: 'Wprowadź kod biletu',
        verify: 'Zweryfikuj',
        scanHint: 'Zeskanuj kod lub wprowadź ręcznie',
        notFound: 'Bilet nie znaleziony',
        found: 'Bilet znaleziony',
        email: 'E-mail',
        entries: 'Wejść',
        people: 'Osób',
        entryPause: 'Odstęp wejścia (min)',
        purchased: 'Zakupiony',
        validUntil: 'Ważny do',
        event: 'Wydarzenie',
        ticketset: 'Zestaw biletów',
        price: 'Poziom cenowy',
        zones: 'Strefy',
        noZones: 'Bilet nie jest przypisany do żadnej strefy.',
        slots: 'Sloty',
        noSlots: 'Bilet nie jest przypisany do żadnego slotu.',
        usageForZone: 'Wykorzystanie w strefie',
        remains: 'Pozostało',
        usageLogs: 'Dziennik użycia biletów',
        showDebug: 'Q',
        debugQuery: 'Query',
        debugData: 'Data',
        newSearch: 'Nowa weryfikacja'
    }
} as const
